import type { StoreApi } from 'zustand/vanilla';
import type { EditAreaDraftState } from '@/entities/edit-area';

const FALLBACK_REASON = '입력을 적용할 수 없습니다.';

/**
 * 폼의 '적용'이 store 커맨드를 실행하고 거부 사유를 돌려준다 — 적용되면 null.
 * 커맨드는 사유를 state.commandError 에만 남기고 다음 commit() 이 그것을 지우므로,
 * 폼이 지역 상태로 붙들 수 있게 실행 직후에 읽어 넘긴다.
 */
export const applyEditAreaCommand = (
  store: StoreApi<EditAreaDraftState>,
  run: () => boolean,
): string | null => (run() ? null : (store.getState().commandError ?? FALLBACK_REASON));
